import { render, staticRenderFns } from "./WatchRouter.vue?vue&type=template&id=72f701a4&"
import script from "./WatchRouter.vue?vue&type=script&lang=js&"
export * from "./WatchRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports